module.exports = __webpack_public_path__ + "media/images/proof_links/periscope-126481174ebde76f4f6569597d649414.svg";